import { useState } from "react";
import CourseList from "@/components/CourseList";
import isCourseExpired from "@/utils/courseExpiry";
import { Navigate, Outlet } from "react-router-dom";

const Curriculum = () => {
  const courseExpired = isCourseExpired();
  const [sidebarOpen, setSidebarOpen] = useState(true);

  if (courseExpired) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="flex h-full w-full relative">

      {/* Sidebar */}
      <div
        style={{
          width: sidebarOpen ? "220px" : "0px",
          minWidth: sidebarOpen ? "220px" : "0px",
          borderRight: sidebarOpen ? "1px solid #d9dee5" : "none",
          overflowY: "auto",
          overflowX: "hidden",
          transition: "width 0.25s ease, min-width 0.25s ease",
        }}
      >
        {sidebarOpen && <CourseList />}
      </div>

      {/* Toggle button */}
      <button
        onClick={() => setSidebarOpen(!sidebarOpen)}
        className="absolute top-2 z-20 bg-white border border-gray-300 rounded-md px-1.5 py-0.5 shadow-sm hover:bg-gray-50 text-gray-500 text-xs font-medium"
        style={{ left: sidebarOpen ? "206px" : "6px" }}
        title={sidebarOpen ? "Collapse sidebar" : "Expand sidebar"}
      >
        {sidebarOpen ? "◀" : "▶"}
      </button>

      {/* Main content */}
      <div
        style={{
          flex: 1,
          overflowX: "auto",
          minWidth: 0,
          transition: "all 0.25s ease",
        }}
      >
        <Outlet />
      </div>

    </div>
  );
};

export default Curriculum;
